import { render } from "./NavItemDesktop.vue?vue&type=template&id=0a465e38&scoped=true"
import script from "./NavItemDesktop.vue?vue&type=script&lang=js"
export * from "./NavItemDesktop.vue?vue&type=script&lang=js"

import "./NavItemDesktop.vue?vue&type=style&index=0&id=0a465e38&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0a465e38"

export default script